import React from 'react';

import FeaturedPropertyListingItem from '$partials/items/featured-property-listing-item';
import PropertyListingItem from '$partials/items/property-listing-item';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/listings.d.ts').PropertyListView}
 */
const PropertyListView = ({
    featuredProperty,
    isUnfiltered,
    listing,
}) => {
    const showFeatured = isUnfiltered && featuredProperty && listing.items?.length > 2;

    return (
        <>
            {/* Items before featured property - responsive counts */}
            {showFeatured && (
                <div className='layout-container layout-site-outer-padding flex py-16 sm:py-24 overflow-hidden'>
                    <div className='sm:-mx-16 md:-mx-24'>
                        <div
                            aria-busy={listing.loading}
                            aria-label='Properties'
                            className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-40${(listing.loading && listing.page === 1) ? ' pointer-events-none opacity-50' : ''}`}
                            role='feed'>
                            {listing.items.map(
                                /** @type {(edge: { node: import("$types/generated/cms-graphql.d.ts").SalePropertyListingItemFragment | import("$types/generated/cms-graphql.d.ts").RentalPropertyListingItemFragment }, i: number) => any} */
                                (edge, i) => {
                                    const { node } = edge;
                                    // Mobile: show after 2, SM: show after 6, MD+: show after 3
                                    const showMobile = i < 2;
                                    const showSm = i < 6;
                                    const showMd = i < 3;

                                    return (
                                        <article
                                            className={`sm:px-16 md:px-24 sm:border-l sm:border-l-tint-dark ${i % 3 === 0 ? 'md:border-opacity-0' : 'md:border-opacity-20'} ${i % 2 === 0 ? 'sm:border-opacity-0' : 'sm:border-opacity-20'} ${!showMobile ? 'hidden' : ''} ${!showSm ? 'sm:hidden' : 'sm:block'} ${!showMd ? 'md:hidden' : 'md:block'}`}
                                            key={`${i}-${node.id}`}>
                                            <PropertyListingItem
                                                {...node}
                                                prioritiseLoad={i < 3} />
                                        </article>
                                    );
                                }
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Featured Property - Full Width */}
            {showFeatured && featuredProperty && (
                <FeaturedPropertyListingItem {...featuredProperty} />
            )}

            {/* Remaining items or all items if no featured */}
            <div className='layout-container layout-site-outer-padding flex py-16 sm:py-24 overflow-hidden'>
                <div className='sm:-mx-16 md:-mx-24'>
                    <div
                        aria-busy={listing.loading}
                        aria-label='Properties'
                        className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-40${(listing.loading && listing.page === 1) ? ' pointer-events-none opacity-50' : ''}`}
                        role='feed'>
                        {listing.items?.length > 0 ? listing.items.map(
                            /** @type {(edge: { node: import("$types/generated/cms-graphql.d.ts").SalePropertyListingItemFragment | import("$types/generated/cms-graphql.d.ts").RentalPropertyListingItemFragment }, i: number) => any} */
                            (edge, i) => {
                                const { node } = edge;

                                if (showFeatured) {
                                    // Mobile: show from 2+, SM: show from 6+, MD+: show from 3+
                                    const showMobile = i >= 2;
                                    const showSm = i >= 6;
                                    const showMd = i >= 3;

                                    return (
                                        <article
                                            className={`sm:px-16 md:px-24 sm:border-l sm:border-l-tint-dark ${i % 3 === 0 ? 'md:border-opacity-0' : 'md:border-opacity-20'} ${i % 2 === 0 ? 'sm:border-opacity-0' : 'sm:border-opacity-20'} ${!showMobile ? 'hidden' : ''} ${!showSm ? 'sm:hidden' : 'sm:block'} ${!showMd ? 'md:hidden' : 'md:block'}`}
                                            key={`${i}-${node.id}`}>
                                            <PropertyListingItem {...node} />
                                        </article>
                                    );
                                }

                                return (
                                    <article
                                        className={`sm:px-16 md:px-24 sm:border-l sm:border-l-tint-dark ${i % 3 === 0 ? 'md:border-opacity-0' : 'md:border-opacity-20'} ${i % 2 === 0 ? 'sm:border-opacity-0' : 'sm:border-opacity-20'}`}
                                        key={`${i}-${node.id}`}>
                                        <PropertyListingItem {...node} />
                                    </article>
                                );
                            }
                        ) : (
                            <div className='sm:px-16 md:px-24 py-56 type-style-3'>
                                No results
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default PropertyListView;
